/* eslint-disable max-len */
import { SvgProps } from './types'

export const SecureHouseIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M31.4304 29.4286V36.0095H4.81738V20.0416"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1761 10.7353L18.0339 8.94516L2 22.3379V17.8957L18.0339 4.50293L22.4541 8.19684"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3467 35.6498V23.2732H21.8996V35.6755"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8013 24.9935H7.38477V31.0168H11.8013V24.9935Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8628 29.1166V31.0168H24.4463V26.0867"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.2271 26.7543C28.0372 26.0683 26.1517 24.8285 24.7578 23.1484C23.2501 21.3363 22.4541 19.1867 22.4541 16.9308V10.2142C25.2493 9.94278 27.9271 9.03672 30.2271 7.58777C31.4156 8.33976 32.7068 8.94502 34.0824 9.39988C35.3516 9.81439 36.6612 10.0895 38.0001 10.2179V16.9344C38.0001 19.1904 37.2041 21.3436 35.6964 23.1521C34.2988 24.8321 32.417 26.072 30.2271 26.758V26.7543Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.625 17.6166L30.0878 20.7382L34.7575 13.5999"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
